import React from 'react';
import { Trans, useTranslation } from 'next-i18next';
import IosAddIcon from 'src/components/icons/IosAdd';
import IosShareIcon from 'src/components/icons/IosShare';
import MoreVertIcon from 'src/components/icons/MoreVert';
import SwipeableDrawer from 'src/components/SwipeableDrawer';
import usePromptInstallation from 'src/hooks/usePromptInstallation';
import { setBeforeInstallPromptDismiss, setIsBeforeInstallPromptOpen, useAuthorizedContext, useAuthorizedDispatch } from '../providers/AuthorizedProvider';
import * as S from './Shortcut.styles';
export const Shortcut = () => {
  const {
    t
  } = useTranslation();
  const dispatch = useAuthorizedDispatch();
  const {
    isAndroid,
    isIOS
  } = usePromptInstallation();
  const {
    isBeforeInstallPromptOpened
  } = useAuthorizedContext();
  const handleDismiss = () => {
    dispatch(setIsBeforeInstallPromptOpen(false));
    dispatch(setBeforeInstallPromptDismiss(true));
  };
  const ShareIcon = isAndroid ? MoreVertIcon : IosShareIcon;
  const AddAndroidIcon = isAndroid ? S.HomeScreenIcon : React.Fragment;
  const AddIosIcon = isIOS ? IosAddIcon : React.Fragment;
  return /*#__PURE__*/React.createElement(SwipeableDrawer, {
    open: isBeforeInstallPromptOpened,
    closeDrawer: () => dispatch(setIsBeforeInstallPromptOpen(false))
  }, /*#__PURE__*/React.createElement(S.Title, null, t('b2c.shortcut.title')), /*#__PURE__*/React.createElement(S.Description, null, t('b2c.shortcut.description')), /*#__PURE__*/React.createElement(S.List, null, /*#__PURE__*/React.createElement(S.Item, {
    bold: true
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "b2c.shortcut.step1",
    components: [/*#__PURE__*/React.createElement(ShareIcon, {
      key: 1
    })]
  })), /*#__PURE__*/React.createElement(S.Item, null, t('b2c.shortcut.step2')), /*#__PURE__*/React.createElement(S.Item, {
    bold: true
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "b2c.shortcut.step3",
    components: [/*#__PURE__*/React.createElement(AddAndroidIcon, {
      key: 1
    }), /*#__PURE__*/React.createElement(AddIosIcon, {
      key: 2
    })]
  }))), /*#__PURE__*/React.createElement(S.DissmisButton, {
    onClick: handleDismiss
  }, t('b2c.shortcut.dismiss')));
};